'use strict';

$(window).trigger('scroll');

/*
  Remove the "hide-on-load" css class
  Which is used to fix visual glitches when js is not ready
 */
$('.hide-on-load').removeClass('hide-on-load');
